import PropTypes from 'prop-types';
import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
  Note,
  Layp,
  BlobProvider,
  pdf
} from '@react-pdf/renderer';
import moment from 'moment-timezone';
import moment_ from 'moment';
import 'moment/min/locales';
import indexFinder from '../utils/indexFinder';
import { getBaseURL, getAPIURL } from '../utils/envGetter';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTop: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  pageWaterMarked: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTopWaterMarked: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  watermarked: {
    transform: 'rotate(-35deg)',
    zIndex: 1,
    position: 'absolute',
    marginLeft: '25%',
    marginTop: '50%'
  },
  section: {
    marginBottom: 5,
    flexGrow: 1
  },
  subSection: {
    marginBottom: 5,
    flexGrow: 1
  },
  textRegular: {
    fontSize: 9,
    fontFamily: 'Bookos',
    fontWeight: 'normal',
    color: '#424242'
  },
  textBold: {
    fontSize: 10,
    fontFamily: 'Bookos',
    fontWeight: 'bold',
    color: '#424242'
  },
  textTitle: {
    fontSize: 11,
    fontFamily: 'Bookos',
    fontWeight: 'black',
    color: '#424242'
  }
});

const PDFRendererForVpn = ({ Header, BodyPermohonan, informations, decoded, layanan }) => {
  const data = '13';
  const ROWHEIGHT = 90;
  const PADDINGTEXT = 4;
  const FONTSIZE = 12;
  const SUBFONTSIZE = 10;
  const SUBSUBFONTSIZE = 6.5;
  const BORDERCOLOR = '#454F5B';

  const now = moment.tz('Asia/Jakarta');

  const filterBiodata = [
    'requestor_name',
    'requestor_id',
    'requestor_jabatan',
    'requestor_instansi'
  ];

  const kebutuhanVPN = layanan.meta?.data_permohonan?.metadata?.answers?.requestor_kebutuhan;

  const filterTarget = [
    'requestor_nama_penerima_akses',
    'requestor_nipnik_penerima_akses',
    'requestor_instansi_penerima_akses',
    'requestor_jabatan_penerima_akses',
    'requestor_hp_penerima_akses',
    'requestor_email_penerima_akses',
    'requestor_email_penerima_akses'
  ];
  const filteredBiodata = informations.filter((item) => filterBiodata.includes(item.id));
  const filteredTarget = informations.filter((item) => filterTarget.includes(item.id));

  const statements = [
    'Tunduk dan patuh kepada seluruh ketentuan yang terkait pengelolaan dan pengamanan teknologi informasi yang berlaku di Dinas Komunikasi dan Informatika DIY;',
    'Selalu menjaga Informasi Rahasia milik Dinas Komunikasi dan Informatika Pemda DIY sesuai ketentuan dan prosedur yang berlaku;',
    'Tidak mengungkap, menyalin, memperbanyak, atau meminjamkan Informasi Rahasia untuk maksud apapun diluar tugas dan tanggung jawab saya selama penugasan di Dinas Komunikasi dan Informatika Pemda DIY;',
    'Tidak menyalahgunakan wewenang atas akses ke sistem informasi yang terdapat di DInas Komunikasi dan Informatika Pemda DIY;',
    'Tidak memberikan User ID dan Password saya kepada pihak lain;',
    'Apabila terbukti bahwa saya melakukan pelanggaran atas perihal yang telah dinyatakan dalam surat ini, maka saya bersedia dikenakan sanksi sesuai dengan peraturan yang berlaku'
  ];

  // const filterKonten = ['requestor_nama', 'requestor_id', 'requestor_instansi', 'activity_name'];
  // const filteredKonten = informations.filter((item) => filterKonten.includes(item.id));

  function PenandaTangan({ informations, decoded, layanan }) {
    const recommenderNama = layanan.meta?.data_permohonan?.metadata?.answers?.requestor_name;
    const recommenderNIP = layanan.meta?.data_permohonan?.metadata?.answers?.requestor_id;
    // const recommenderInstansi =
    //   layanan.meta?.data_permohonan?.metadata?.answers?.requestor_instansi;

    function Approver({ informations, decoded, layanan }) {
      return (
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <View
            style={{
              height: 50,
              alignItems: 'center',
              paddingBottom: 10,
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              Yogyakarta, {moment.tz(now, 'Asia/Jakarta').format('DD-MM-YYYY')}
            </Text>
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              KEPALA
            </Text>

            {/* <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              {recommenderInstansi}
            </Text> */}
          </View>

          <View style={{ paddingBottom: 5 }}>
            {/* decoded.modeTandaTangan === 'tte' disable remove qrcode */}
            {decoded.modeTandaTangan === 'tte' ? (
              <Image
                allowDangerousPaths
                src={`${getAPIURL()}/qrcodes?id=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[5]
                }&year=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[3]
                }&month=${
                  layanan?.meta?.[decoded.selectedRequirement.type]?.metadata?.qr_code_path?.split(
                    '/'
                  )[4]
                }`}
                style={{ width: 75, height: 75 }}
              />
            ) : (
              <View style={{ width: 75, height: 75 }} />
            )}
          </View>

          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textDecoration: 'underline',
              textAlign: 'center'
            }}
          >
            {recommenderNama}
          </Text>
          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            NIP. {recommenderNIP}
          </Text>
        </View>
      );
    }

    return (
      <View
        break
        style={{
          paddingTop: 10,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />

        <Approver informations={informations} decoded={decoded} layanan={layanan} />
      </View>
    );
  }
  return (
    <View>
      <View>{Header}</View>
      <View
        fixed
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            maxLines: 2,
            textOverflow: 'ellipsis'
          }}
        >
          Dengan hormat, Saya yang bertandatangan di bawah ini:
        </Text>
      </View>
      <View
        style={{
          ...styles.section,
          borderTop: 0,
          borderLeft: 0,
          borderRight: 0,
          borderColor: BORDERCOLOR
        }}
      >
        {filteredBiodata.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 0,
              minHeight: 25,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                padding: 2,
                minWidth: '30%',
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '30%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2,
                  maxLines: 2,
                  textOverflow: 'ellipsis'
                }}
              >
                {item.label}
              </Text>
            </View>
            <View
              style={{
                padding: 2,
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                minWidth: '70%',
                borderLeft: 0
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '70%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2
                }}
              >
                &nbsp; : {item.answer}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View
        fixed
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            paddingTop: 5,
            maxLines: 2,
            textOverflow: 'ellipsis'
          }}
        >
          Melalui surat ini mengajukan permohonan akses VPN untuk keperluan
          <Text style={{ fontWeight: 'bold' }}>&nbsp;{kebutuhanVPN}</Text>. Adapun akses VPN
          tersebut dapat diberikan kepada:
        </Text>
      </View>
      <View
        style={{
          ...styles.section,
          borderTop: 0,
          borderLeft: 0,
          borderRight: 0,
          borderColor: BORDERCOLOR
        }}
      >
        {filteredTarget.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 0,
              minHeight: 25,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                padding: 2,
                minWidth: '30%',
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '100%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2,
                  maxLines: 2,
                  textOverflow: 'ellipsis'
                }}
              >
                {item.label}
              </Text>
            </View>
            <View
              style={{
                padding: 2,
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                minWidth: '70%',
                borderLeft: 0
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '70%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2
                }}
              >
                &nbsp; : {item.answer}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View
        fixed
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            paddingTop: 5,
            maxLines: 2,
            textOverflow: 'ellipsis'
          }}
        >
          Dengan ini kami menyatakan:
        </Text>
      </View>
      <View
        style={{
          ...styles.section,
          borderTop: 0,
          borderLeft: 0,
          borderRight: 0,
          borderColor: BORDERCOLOR
        }}
      >
        {statements.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 0,

              borderColor: BORDERCOLOR
            }}
          >
            <Text
              style={{
                ...styles.textRegular,
                width: '100%',
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                paddingLeft: 2,
                maxLines: 2,
                textOverflow: 'ellipsis'
              }}
            >
              {index + 1}. {item}
            </Text>
          </View>
        ))}
      </View>
      <View
        fixed
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            paddingTop: 5,
            maxLines: 2,
            textOverflow: 'ellipsis'
          }}
        >
          Pernyataan ini tetap berlaku meskipun saya sudah tidak lagi bekerja di/untuk Pemda DIY.
        </Text>
      </View>
      <View
        fixed
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          border: 0,
          borderWidth: 0,
          marginBottom: 5,
          width: '100%',
          borderColor: BORDERCOLOR
        }}
      >
        <Text
          style={{
            ...styles.textRegular,
            width: '100%',
            fontFamily: 'Bookos',
            fontWeight: 'normal',
            paddingLeft: 2,
            paddingTop: 5,
            maxLines: 2,
            textOverflow: 'ellipsis'
          }}
        >
          Demikian surat permohonan ini dibuat untuk dapat pergunakan sebagaimana mestinya.
        </Text>
      </View>
      <View>
        <PenandaTangan informations={informations} decoded={decoded} layanan={layanan} />
      </View>
    </View>
  );
};

export default PDFRendererForVpn;
